import React, {useEffect, useState} from 'react';
import {getUserLogos} from 'utils/fetch';

import {ReactComponent as LinkIcon} from 'assets/svgs/actions/link.svg';
import {ReactComponent as ImageIcon} from 'assets/svgs/common/image-black.svg';
import {ReactComponent as DownloadIcon} from 'assets/svgs/actions/download.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/actions/trash.svg';
import LoadingIndicator from 'components/LoadingIndicator';

const ServerCategories = ({
  filter,
  onSelectLogo,
  searchKey,
  userDetails,
  type,
  typeKey,
}) => {
  const [logoList, setLogoList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const getLogos = async () => {
    setLoaded(false);
    const logos = await getUserLogos({
      authToken: userDetails.authToken,
      searchKey,
    });
    setLogoList(logos);
    setLoaded(true);
  };
  useEffect(() => {
    getLogos();
  }, [searchKey]);
  const selectedLogos = () => {
    if (filter === 2) return logoList.filter((f) => f[typeKey].length === 0);
    if (filter === 3) return logoList.filter((f) => f[typeKey].length > 0);
    return logoList;
  };

  if (logoList.length === 0 && !loaded) return <LoadingIndicator />;
  if (logoList.length === 0)
    return (
      <div className={`gallery-section p-4 ${type}-gallery`}>
        Logos not found!
      </div>
    );

  return (
    <div className={`gallery-section p-4 ${type}-gallery`}>
      <ul className="p-0 w-100">
        {selectedLogos().map((logo) => (
          <li key={logo._id}>
            <div className="gallery-items">
              <div className="img-gallery">
                <img
                  src={`${logo.liveURL}`}
                  alt=""
                  className={`${logo[typeKey].length > 0 ? 'active' : ''}`}
                />
                {logo[typeKey].length > 0 && (
                  <div className="corner">
                    <span>{logo[typeKey].length}</span>
                  </div>
                )}
              </div>
              <p>{logo.name}</p>

              <div className="hover-icon rounded">
                <div className="link-logo text-center d-flex flex-wrap justify-content-around">
                  <a
                    href="#test"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <DeleteIcon />
                  </a>
                  <a href={`${logo.liveURL}`} target="_blank">
                    <LinkIcon />
                  </a>
                  <a href="#test">
                    <DownloadIcon />
                  </a>
                  <a
                    href="#test"
                    onClick={(e) => {
                      e.preventDefault();
                      onSelectLogo(logo);
                    }}
                  >
                    <ImageIcon />
                  </a>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServerCategories;
